import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const getNavigationRequest = () => ({
  type: 'GET_NAVIGATION_REQUEST',
})

export const getNavigationSuccess = (navigationData) => ({
  type: 'GET_NAVIGATION_SUCCESS',
  navigationData,
})

export const getNavigationFailure = (error) => ({
  type: 'GET_NAVIGATION_FAILURE',
  error,
})

export const addNavigationRequest = () => ({
  type: 'ADD_NAVIGATION_REQUEST',
})

export const addNavigationSuccess = (newNavigation) => ({
  type: 'ADD_NAVIGATION_SUCCESS',
  newNavigation,
})

export const addNavigationFailure = (error) => ({
  type: 'ADD_NAVIGATION_FAILURE',
  error,
})

export const updateNavigationRequest = () => ({
  type: 'UPDATE_NAVIGATION_REQUEST',
})

export const updateNavigationSuccess = (updatedNavigation) => ({
  type: 'UPDATE_NAVIGATION_SUCCESS',
  updatedNavigation,
})

export const updateNavigationFailure = (error) => ({
  type: 'UPDATE_NAVIGATION_FAILURE',
  error,
})

export const deleteNavigationRequest = () => ({
  type: 'DELETE_NAVIGATION_REQUEST',
})

export const deleteNavigationSuccess = (id) => ({
  type: 'DELETE_NAVIGATION_SUCCESS',
  id,
})

export const deleteNavigationFailure = (error) => ({
  type: 'DELETE_NAVIGATION_FAILURE',
  error,
})

export const getNavigation = () => {
  return (dispatch) => {
    dispatch(getNavigationRequest())

    fetch(URL.BASE_URL + URL.END_POINT.navigation, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((navigationData) => {
        dispatch(getNavigationSuccess(navigationData))
      })
      .catch((error) => {
        dispatch(getNavigationFailure(error.message))
        toast(error.message, { type: 'error' })
      })
  }
}

export const addNavigation = (payload) => {
  return (dispatch) => {
    dispatch(addNavigationRequest())

    fetch(URL.BASE_URL + URL.END_POINT.navigation, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        const data = await response.json()
        if (!response.ok) {
          throw new Error(data.message || 'Failed to add navigation')
        }
        dispatch(addNavigationSuccess(data.data))
        toast.success('Navigation added successfully')
        dispatch(getNavigation())
      })
      .catch((error) => {
        dispatch(addNavigationFailure(error.message))
        toast.error(error.message || 'Error adding navigation')
      })
  }
}

export const updateNavigation = (payload) => {
  return (dispatch) => {
    dispatch(updateNavigationRequest())

    fetch(URL.BASE_URL + URL.END_POINT.navigation, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        const data = await response.json()
        if (!response.ok) {
          throw new Error(data.message || 'Failed to update navigation')
        }
        dispatch(updateNavigationSuccess(data.data))
        toast.success('Navigation updated successfully')
        dispatch(getNavigation())
      })
      .catch((error) => {
        dispatch(updateNavigationFailure(error.message))
        toast.error(error.message || 'Error updating navigation')
      })
  }
}

export const deleteNavigation = (id) => {
  return (dispatch) => {
    dispatch(deleteNavigationRequest())

    fetch(URL.BASE_URL + URL.END_POINT.navigation, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({ id }),
    })
      .then(async (response) => {
        const data = await response.json()
        if (!response.ok) {
          throw new Error(data.message || 'Failed to delete navigation')
        }
        dispatch(deleteNavigationSuccess(id))
        toast.success('Navigation deleted successfully')
        dispatch(getNavigation())
      })
      .catch((error) => {
        dispatch(deleteNavigationFailure(error.message))
        toast.error(error.message || 'Error deleting navigation')
      })
  }
}

const initialState = {
  navigationData: null,
  loadingNavigation: false,
  errorNavigation: null,
}

export const navigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_NAVIGATION_REQUEST':
      return {
        ...state,
        loadingNavigation: true,
        errorNavigation: null,
      }
    case 'GET_NAVIGATION_SUCCESS':
      return {
        ...state,
        navigationData: action.navigationData.data,
        loadingNavigation: false,
        errorNavigation: null,
      }
    case 'GET_NAVIGATION_FAILURE':
      return {
        ...state,
        loadingNavigation: false,
        errorNavigation: action.error,
      }
    default:
      return state
  }
}
